import React from 'react';
import { motion } from 'framer-motion';

const Section = ({ children, className = '', id }) => (
  <section id={id} className={`py-24 md:py-36 relative ${className}`}>
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
      className="max-w-7xl mx-auto px-6 md:px-12 relative z-10"
    >
      {children}
    </motion.div>
  </section>
);

export default Section;